import { FormInput, InfoBox, TabsNavigation } from 'components/molecules';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarTabs } from 'components/templates';
import { Form, Formik, FormikConfig } from 'formik';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { IRegisterUserForm } from 'services/clientUserManagment/types';
import { II18nextPrefix } from 'types/components/components.interface';
import { object, string } from 'yup';
import { IFormikProps, IFormProps } from '../types';
import ClientUserAccountsTab from './tabs/ClientUserAccountsTab';

const validationSchema = object().shape({
  userName: string().required(() => {
    return i18next.t('formik-error.required');
  }),
  email: string()
    .email(() => i18next.t('formik-error.invalid-email'))
    .required(() => {
      return i18next.t('formik-error.required');
    })
    .email(() => i18next.t('formik-error.invalid-email')),
  phoneNumber: string().required(i18next.t('formik-error.required')),
  firstName: string().required(i18next.t('formik-error.required')),
  lastName: string().required(i18next.t('formik-error.required')),
});

export const userFormInitialValues: IRegisterUserForm = {
  email: '',
  phoneNumber: '',
  userName: '',
  firstName: '',
  lastName: '',
  isActive: true,
  isTwoFactorEnabled: false,
};

export interface IUserForm
  extends FormikConfig<IRegisterUserForm>,
    IFormProps,
    II18nextPrefix {}

const ClientUserForm = ({
  i18nextPrefix,
  status,
  topbarContent,
  tittle,
  disableTabs,
  backPath,
  customBackItem,
  initialValues,
  ...props
}: IUserForm) => {
  const { t } = useTranslation();

  const disableInputs =
    !!initialValues.userName ||
    !!initialValues.email ||
    !!initialValues.phoneNumber ||
    !!initialValues.firstName ||
    !!initialValues.lastName;

  return (
    <Formik
      {...props}
      validationSchema={validationSchema}
      initialStatus={status}
      validateOnChange={true}
      validateOnBlur={true}
      enableReinitialize={true}
      initialValues={initialValues}>
      {({
        status,
        values,
        errors,
        setFieldValue,
      }: IFormikProps<IRegisterUserForm>) => (
        <Form className='w-full h-full'>
          <TopbarTabs>
            <TopBar
              title={tittle}
              customBackItem={customBackItem}
              path={backPath ?? 'settings/client-users'}
              topbarContent={
                <div className='flex w-full gap-4 items-center'>
                  <FormInput.Switch
                    name='isActive'
                    label={t('input.label.isActive')}
                    checked={values.isActive}
                    className={`${
                      status?.displayMode
                        ? 'pointer-events-none'
                        : 'pointer-events-auto'
                    }`}
                  />
                  <div className='w-full flex items-center'>
                    {/* <FormInput.Switch
                        className={`${
                          status?.displayMode
                            ? "pointer-events-none"
                            : "pointer-events-auto"
                        }`}
                        name="isTwoFactorEnabled"
                        label={t("input.label.isTwoFactorEnabled")}
                        checked={values.isTwoFactorEnabled}
                      /> */}
                  </div>
                  <div>{topbarContent}</div>
                </div>
              }>
              <InfoBox loading={status?.isLoading}>
                <InfoBox.Items columns={2}>
                  <FormInput.Text
                    name='userName'
                    label={t('input.label.nickname')}
                    autoFocus
                    disabled={disableInputs}
                  />
                  <FormInput.Text
                    name='firstName'
                    label={t('input.label.firstName')}
                    disabled={disableInputs}
                  />
                  <FormInput.Text
                    name='lastName'
                    label={t('input.label.lastName')}
                    disabled={disableInputs}
                  />
                  <FormInput.Text
                    name='email'
                    label={t('input.label.email')}
                    disabled={disableInputs}
                  />
                  <FormInput.Text
                    name='phoneNumber'
                    label={t('input.label.phoneNumber')}
                    disabled={disableInputs}
                  />
                </InfoBox.Items>
              </InfoBox>
              <TabsNavigation
                tabs={[
                  {
                    value: 0,
                    name: 'accounts',
                  },
                ]}
                disabled={disableTabs}
                i18nextPrefix={i18nextPrefix}
              />
            </TopBar>
          </TopbarTabs>
        </Form>
      )}
    </Formik>
  );
};

ClientUserForm.getRouterTabs = (disabledChildren?: string[]) =>
  [
    {
      path: 'accounts',
      element: <ClientUserAccountsTab />,
    },
  ].filter(children => !disabledChildren?.includes(children.path));

export default ClientUserForm;
